import { z } from "zod";
import { cents } from "./money.js";
/**
 * The catalog is owned by ERPNext. This module only describes the shape the
 * app is allowed to rely on, so a surprise from the ERP (a renamed item, a
 * null rate, a negative bin) fails at the boundary instead of halfway through
 * a checkout.
 */
export const itemCodeSchema = z
    .string()
    .min(2)
    .max(140)
    .regex(/^[A-Za-z0-9][A-Za-z0-9._/-]*$/, "item_code has an unexpected shape");
export const FAMILIES = ["fresh", "a2", "barista", "light", "kids"];
/** Wire shape: prices in cents, integers only, so JSON carries no floats. */
export const productSchema = z.object({
    code: itemCodeSchema,
    nameEn: z.string().min(1),
    nameKh: z.string().min(1),
    priceCents: z.number().int().nonnegative(),
    /** Counted balance at the selling warehouse. Never below zero. */
    stock: z.number().int().nonnegative(),
    family: z.enum(FAMILIES),
    /** False when the item exists on the price sheet but not yet in ERPNext. */
    inErp: z.boolean().default(true),
    image: z.string().min(1).optional(),
});
export const catalogSchema = z.object({
    /** When the ERP was last read. Clients show staleness rather than hiding it. */
    fetchedAt: z.string().datetime(),
    /** True when served from cache because the ERP was unreachable. */
    stale: z.boolean(),
    products: z.array(productSchema).min(1),
});
export function hydrate(wire) {
    const { priceCents, ...rest } = wire;
    return { ...rest, price: cents(priceCents) };
}
export function hydrateCatalog(wire) {
    return wire.products.map(hydrate);
}
export function isSellable(p) {
    return p.inErp && p.stock > 0 && p.price > 0;
}
//# sourceMappingURL=catalog.js.map